module.exports = __webpack_public_path__ + "static/img/video.07c8ad1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/video.png
// module id = c0JR
// module chunks = 0